import React from 'react';
import styles from './loginHeaderStyles';
import { Container, Typography } from '@mui/material';

const LoginHeader = () => {      
  return (
    <Container style={styles.container}>
      <img src="https://assets-liber.s3.amazonaws.com/images/liber_logo.jpeg" style={styles.logoImage} alt='Logo de Liber' />
      <Typography variant="h4" sx={styles.title} gutterBottom>
        Bienvenido 👋🏼
      </Typography>
      <Typography variant="body2" sx={styles.subtitle} gutterBottom >
        Ingresa tu información de usuario y que comienze la administración
      </Typography>
    </Container>
  );
};

export default LoginHeader;
